import { useMemo } from 'react'
import './SineThinkingLoader.css'

type SineThinkingLoaderProps = {
  label?: string
  size?: 'xs' | 'sm' | 'md'
  tone?: 'auto' | 'dark' | 'light'
  showText?: boolean
  className?: string
}

function buildSineLoaderPath(scale = 52, steps = 240): string {
  let path = ''
  for (let index = 0; index <= steps; index += 1) {
    const theta = (index / steps) * Math.PI * 2
    const radius = 2 * Math.sin(4 * theta)
    const x = radius * Math.cos(theta) * scale
    const y = -radius * Math.sin(theta) * scale
    path += index === 0 ? `M ${x} ${y}` : ` L ${x} ${y}`
  }
  return path
}

export function SineThinkingLoader({
  label = 'Tenker...',
  size = 'md',
  tone = 'auto',
  showText = true,
  className,
}: SineThinkingLoaderProps) {
  const path = useMemo(() => buildSineLoaderPath(), [])
  const classes = [
    'sine-thinking-loader',
    `sine-thinking-loader--${size}`,
    tone !== 'auto' ? `sine-thinking-loader--${tone}` : '',
    !showText ? 'sine-thinking-loader--icon-only' : '',
    className ?? '',
  ].filter(Boolean).join(' ')

  return (
    <span className={classes} aria-label={showText ? undefined : label} role="status">
      <span className="sine-thinking-loader__spinner" aria-hidden="true">
        <svg className="sine-thinking-loader__svg" viewBox="-130 -130 260 260" focusable="false">
          <path className="sine-thinking-loader__path" d={path} pathLength={1} />
        </svg>
      </span>
      {showText && <span className="sine-thinking-loader__text">{label}</span>}
    </span>
  )
}
